"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormPanel = void 0;
const react_1 = __importStar(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const panel_1 = require("../../../components/panel/panel");
exports.FormPanel = react_1.forwardRef(function FormPanel({ children, ...props }, ref) {
    return (react_1.default.createElement(Grid_1.default, { "data-cy": "EAS__FORM_PANEL", item: true, xs: 12 },
        react_1.default.createElement(panel_1.Panel, Object.assign({}, props, { ref: ref }),
            react_1.default.createElement(Grid_1.default, { container: true, spacing: 0 }, children))));
});
//# sourceMappingURL=form-panel.js.map